import React from 'react';

const AboutUs = () => (
	<div className="container main">
		<h2>포털 정보</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>OECD 소비자제품안전작업반(Working Party on Consumer Product Safety)</h4>
				<p>
					<em>GlobalRecalls</em> 포털은 <a href="http://www.oecd.org/sti/consumer/consumer-product-safety.htm">OECD 소비자제품안전작업반</a>에 의해 개발했습니다.
					포털의 임무는 다음을 통해 정보 공유를 개선하고 전 세계 제품 안전 시장 감시, 집행 및 규제 당국 간의 협력을 촉진하는 데 중점을 둡니다.
				</p>
				<ul className={'rss-feed-options'}>
					<li>안전 문제 조기 파악</li>
					<li>관행 및 정책 법률 개발 정보 공유</li>
					<li>일관된 방식으로 안전 문제 해결</li>
					<li>글로벌 및 지역 포럼 지원</li>
				</ul>
				<p>
					OECD 소비자제품안전작업반의 주요한 성과 중 하나는 <a href="https://legalinstruments.oecd.org/en/instruments/OECD-LEGAL-0459">OECD 소비자 제품 안전에 대한 권고문</a>을 통해 국내외 수준에서 소비자 제품 안전 프레임워크의 중심이 되어야 하는 핵심 원칙을 설명하고, GlobalRecalls 포털 사용을 권장한 것입니다.
					작업반은 정부와 기업에 도움이 되고자 제품 리콜에 대한 보다
					효율적인 기타 리소스도 많이 개발했으며 이 리소스는 <a href="https://www.oecd.org/digital/consumer/consumer-product-safety.htm">웹사이트</a>에서 찾아보실 수 있습니다.
				</p>
			</div>
			<div className="col-sm-6">
				<h4 className="hidden-xs">&nbsp;</h4>
				<p>
					작업반은 <a href="https://www.oecd.org/sti/consumer/">OECD 소비자정책위원회</a>의 책임하에 있으며 이 두 기관은 여러 공동 프로젝트 및 행사와 함께 관련 소비자 보호 문제에 대해 정기적으로 협력합니다.
				</p>
				<p>
					작업반은 또한 동남아시아국가연합(Association of Southeast Asian Nations, ASEAN), 유럽연합 집행위원회(European Commission, EC),
					국제소비자보호집행네트워크(International Consumer Protection Enforcement Network,
					ICPEN), 국제소비자제품보건안전기구(International Consumer Policy Health & Safety Organization, ICPHSO), 미주기구(Organization of American States, OAS)
					및 유엔무역개발기구(United Nations Committee for Trade and Development, UNCTAD)와 긴밀하게 협력하고 있습니다. 작업반은 또한 다수의 OECD 파트너 국가와도 긴밀한 관계를 유지하고 있습니다.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>문의하기</h4>
				<p>
					GlobalRecalls 포털에 대해 문의 사항이나 의견이 있으신 경우, OECD 사무국(<a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>)으로 연락하시기 바랍니다.
				</p>
			</div>
		</div>
	</div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/views/static/ko/about-us.js